module.exports = __webpack_public_path__ + "img/appeal.26018799.png";